import { ArrowDownIcon, Users2Icon } from 'cokitchen-icons';
import { CalculatedOrderMealType } from 'models/meal.model';
import React, { useState } from 'react';
import { formatCurrency, getAssignedUsers } from 'utils/functions';

type Props = {
  meal: CalculatedOrderMealType;
};
const BulkOrderMealAccordion = ({ meal }: Props) => {
  const [show, setShow] = useState(false);
  return (
    <div className='w-full bg-white pt-2 mb-1'>
      <div
        className={`w-full flex justify-between px-[18px] items-center pb-2 cursor-pointer ${
          meal.meals.length > 1 || (show && 'border-b-[1px] border-b-[#EAEBEB]')
        }`}
        onClick={() => setShow(!show)}>
        <div>
          <h3 className='font-semibold text-gray-6 mb-1'>{meal.brand?.name}</h3>
          <p className='text-sm text-gray-9'>
            {meal.meals?.length} {meal.meals?.length === 1 ? 'item' : 'items'}
          </p>
        </div>
        <div className='w-[30px] h-[30px] rounded-full cursor-pointer bg-[#F7F7F7] flex justify-center items-center text-red-5'>
          {show ? <ArrowDownIcon className='transform rotate-180' /> : <ArrowDownIcon />}
        </div>
      </div>
      {show && (
        <div className='w-full pt-2'>
          <ul>
            {meal.meals.map((mealItem, index) => (
              <li
                className={`py-4 px-[18px] 
              
              ${
                index === meal.meals.length - 1 && meal.meals.length === 1
                  ? ''
                  : 'border-b-[1px] border-b-[#EAEBEB]'
              }
              
              `}
                key={index}>
                <div className='w-full flex items-center gap-4 mb-1'>
                  <p className='text-sm text-red-5 font-medium'>{mealItem.quantity}x</p>

                  <article className='flex flex-col gap-[3px]'>
                    <p className='text-sm font-medium leading-[21px]'>{mealItem?.name}</p>
                    <ul>
                      {mealItem.addons?.map((addon) => (
                        <li key={addon.id} className='text-sm text-[#6F7376] leading-[22.4px]'>
                          {addon.quantity}x&nbsp;{addon?.name}
                        </li>
                      ))}
                    </ul>
                  </article>

                  <div className='flex items-center gap-[10px] font-medium ml-auto'>
                    <p>{formatCurrency(meal.amount)}</p>
                  </div>
                </div>
                {mealItem.members?.length ? (
                  <div className='w-full bg-[#F5F5F5] rounded-[6px] py-[8.5px] px-[11px] text-[#5E6164] flex gap-1'>
                    <Users2Icon />
                    <p>{getAssignedUsers(mealItem)}</p>
                  </div>
                ) : null}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default BulkOrderMealAccordion;
